<template>
    <v-container class="pa-0 ma-0">
        <v-row>
            <v-col cols="12">
                <h1>Настройка бота FitInspector</h1>

            </v-col>
        </v-row>
        <v-dialog v-if="compared" v-model="dialogZones" fullscreen hide-overlay transition="dialog-bottom-transition">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" dark v-on="on">Редактор зон</v-btn>
            </template>
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialogZones = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Настройка зон</v-toolbar-title>
                    <div class="flex-grow-1"></div>
                </v-toolbar>
                <v-col cols="6" md="6" sm="12">

                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left">Название</th>
                                <th class="text-left">Действия</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    <v-text-field label="Новая зона" v-model="newzone"></v-text-field>
                                </td>
                                <td>
                                    <v-btn @click="addZone" small color="success">
                                        <v-icon dark :disabled="newzone === null || newzone === ''">mdi-plus</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            <tr v-for="item in zones" :key="item.zone_id">
                                <td>
                                    <v-text-field v-model="item.zone_name"></v-text-field>
                                </td>
                                <td>
                                    <v-btn color="warning" class="mr-3" small @click="deleteZone(item.zone_id)">
                                        <v-icon dark>mdi-close</v-icon>
                                    </v-btn>
                                    <v-btn color="success" small @click="patchZone(item)">
                                        <v-icon dark>mdi-content-save-outline</v-icon>
                                    </v-btn>
                                </td>
                            </tr>

                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-if="compared" v-model="dialogQuestions" fullscreen hide-overlay transition="dialog-bottom-transition">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" class="ml-3" dark v-on="on">Редактор вопросов</v-btn>
            </template>
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialogQuestions = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Настройка вопросов</v-toolbar-title>
                    <div class="flex-grow-1"></div>
                </v-toolbar>
                <v-col cols="12">
                    <v-select :items="zones" v-model="selectedZone" item-text="zone_name" item-value="zone_id"
                              label="Зона"></v-select>
                </v-col>
                <v-col cols="12" md="12" sm="12">
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th class="text-left" width="140">Тип</th>
                                <th class="text-left">Текст</th>
                                <th class="text-left" width="130">Может отсутствовать</th>
                                <th class="text-left">ID Файла</th>
                                <th class="text-left" width="90">Код Б24</th>
                                <th class="text-left" width="90">Порядок</th>
                                <th class="text-left" width="280">Действия</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="selectedZone > 0">
                                <td>
                                    <v-select :items="qTypes" dense v-model="newQ.type" item-text="name"
                                              item-value="value" label="Тип"></v-select>
                                </td>
                                <td>
                                    <v-textarea rows="1" dense placeholder="Новый вопрос" v-model="newQ.text"></v-textarea>
                                </td>
                                <td>
                                    <v-checkbox dense v-model="newQ.ifexist" :false-value="0" :true-value="1"></v-checkbox>
                                </td>
                                <td>
                                    <v-textarea rows="1" dense placeholder="Идентификатор файла из телеграм или ничего" v-model="newQ.file"></v-textarea>
                                </td>
                                <td>
                                    <v-text-field dense disabled v-model="newQ.code"></v-text-field>
                                </td>
                                <td>
                                    <v-text-field dense disabled v-model="newQ.order"></v-text-field>
                                </td>
                                <td>
                                    <v-btn @click="addStep" small color="success">
                                        <v-icon dark :disabled="false">mdi-plus</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            <tr v-for="(item, index) in questions" :key="item.question_id">
                                <td>
                                    <v-select :items="qTypes" dense v-model="item.type" item-text="name"
                                              item-value="value" label="Тип"></v-select>
                                </td>
                                <td>
                                    <v-textarea rows="5" dense v-model="item.caption"></v-textarea>
                                </td>
                                <td>
                                    <v-checkbox dense v-model="item.ifexist" :false-value="0" :true-value="1"></v-checkbox>
                                </td>
                                <td>
                                    <v-textarea rows="2" dense v-model="item.file_id"></v-textarea>
                                </td>
                                <td>
                                    <v-text-field dense :disabled="true" v-model="item.code_bx"></v-text-field>
                                </td>
                                <td>
                                    <v-text-field dense :disabled="true" v-model="item.step"></v-text-field>
                                </td>
                                <td>
                                    <v-btn @click="preDeleteQuestion(index)" small color="error" class="mr-1">
                                        <v-icon dark>mdi-delete</v-icon>
                                    </v-btn>
                                    <v-btn @click="itemUp(index)" small color="info" :disabled="index == 0"
                                           class="mr-1">
                                        <v-icon dark>mdi-arrow-up-bold</v-icon>
                                    </v-btn>
                                    <v-btn @click="itemDown(index)" small color="info"
                                           :disabled="index == questions.length - 1" class="mr-1">
                                        <v-icon dark>mdi-arrow-down-bold</v-icon>
                                    </v-btn>
                                    <v-btn @click="saveQuestion(index)" small color="success" class="mr-1">
                                        <v-icon dark>mdi-content-save</v-icon>
                                    </v-btn>
                                </td>
                            </tr>

                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-card>
        </v-dialog>

        <v-dialog v-if="compared" v-model="confirmDeleteQuestion" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Вы действительно хотите удалить этот вопрос?</v-card-title>
                <v-card-text>Внимание! Удаление необратимо!</v-card-text>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="success" text @click="confirmDeleteQuestion = false">Оставить</v-btn>
                    <v-btn color="error" text @click="deleteQuestion(deleteQuestionIndex)">Удалить</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>
<script>
  export default {
    data: () => ({
      compared: false,
      deleteQuestionIndex: 0,
      confirmDeleteQuestion: false,
      dialogZones: false,
      dialogQuestions: false,
      newzone: null,
      newQ: {
        type: 'photo',
        text: '',
        ifexist: 0,
        file: '',
        code: 0,
        order: 1,
        zone_id: 0,
      },
      questions: [],
      selectedZone: null,
      qTypes: [
        { name: 'Текст', value: 'text' },
        { name: 'Да-Нет', value: 'yn' },
        { name: 'Да-Нет (без комментария)', value: 'ynst' },
        { name: 'Фото', value: 'photo' },
        { name: 'Видео', value: 'video' },
      ],
      zones: [],
      api: 'https://sbotapi.fitauto.ru/v3/bots/inspector/'
    }),
    computed: {},
    watch: {
      selectedZone: async function () {
        this.newQ.zone_id = this.selectedZone
        await this.getQuestions(this.selectedZone)
      }
    },
    methods: {
      checkCrypto: async function () {
        try {
          const r = await this.$http.post(`https://sbotapi.fitauto.ru/v3/crypto/inspector`, {
            id: this.$route.query.id,
            first_name: this.$route.query.first_name,
            last_name: this.$route.query.last_name,
            username: this.$route.query.username,
            photo_url: this.$route.query.photo_url,
            auth_date: this.$route.query.auth_date,
            hash: this.$route.query.hash,
          })
          console.log({
            hash: this.$route.query.hash,
            comparedHash: r.data.compareString
          })
          this.compared = r.data.compareString === this.$route.query.hash
        } catch (e) {
          console.log('Hash checking error!')
        }
      },
      addStep: async function () {
        try {
          await this.$http.post(`${this.api}questions`, {
            caption: this.newQ.text,
            ifexist: this.newQ.ifexist,
            file_id: this.newQ.file,
            code_bx: this.newQ.code,
            zone_id: this.newQ.zone_id,
            step: this.newQ.order,
            type: this.newQ.type
          })
          this.newQ.file = ''
          this.newQ.type = 'photo'
          this.newQ.text = ''
          this.newQ.ifexist = 0

          this.getQuestions(this.selectedZone)
        } catch (e) {
          console.log(e)
        }
      },
      deleteQuestion: async function (index) {
        let question_id = this.questions[index].question_id
        this.questions.splice(index, 1)
        let newQuestions = []
        this.questions.forEach(el => {
          newQuestions.push(el)
          newQuestions[newQuestions.length - 1].step = newQuestions.length
        })
        this.questions = newQuestions

        try {
          await this.$http.delete(`${this.api}questions/${question_id}`)
          await this.$http.put(`${this.api}questions/full`, {questions: this.questions})
          this.getQuestions(this.selectedZone)
          this.deleteQuestionIndex = 0
          this.confirmDeleteQuestion = false
        } catch (e) {
          console.log(e)
        }
      },
      preDeleteQuestion: function (index) {
        this.confirmDeleteQuestion = true
        this.deleteQuestionIndex = index
      },
      saveQuestion: async function (index) {
        try {
          await this.$http.put(`${this.api}questions/full`, {questions: [this.questions[index]]})
          this.getQuestions(this.selectedZone)
        } catch (e) {
          console.log('Step state error!')
        }
      },
      itemUp: function (index) {
        let current = this.questions[index]
        this.questions.splice(index, 1)
        current.step = +(current.step) - 1
        this.questions[index - 1].step = +(this.questions[index - 1].step) + 1
        this.questions.splice(index - 1, 0, current)
        try {
          this.$http.put(`${this.api}questions/step`, {questions: this.questions})
          this.codeBx()
        } catch (e) {
          console.log('Step state error!')
        }
      },
      itemDown: function (index) {
        let current = this.questions[index]
        this.questions.splice(index, 1)
        current.step = +(current.step) + 1
        this.questions[index].step = +(this.questions[index].step) - 1
        this.questions.splice(index + 1, 0, current)

        try {
          this.$http.put(`${this.api}questions/step`, {questions: this.questions})
          this.codeBx()
        } catch (e) {
          console.log('Step state error!')
        }
      },
      getQuestions: async function (zone_id) {
        try {
          const r = await this.$http.get(`${this.api}questions/${zone_id}`)
          this.questions = r.data
          this.newQ.order = (this.questions[this.questions.length -1]) ? this.questions[this.questions.length -1].step + 1 : 1
          this.codeBx()
        } catch (e) {
          console.log(e)
        }
      },
      deleteZone: async function (index) {
        console.log(index)
      },
      getZones: async function () {
        try {
          const r = await this.$http.get(`${this.api}zones`)
          this.zones = r.data
        } catch (e) {
          console.log(e)
        }
      },
      addZone: async function () {
        try {
          const r = await this.$http.post(`${this.api}zones`, {
            zone_name: this.newzone
          })
          this.getZones()
          this.newzone = null
        } catch (e) {
          console.log(e)
        }
      },
      deleteZone: async function (zone_id) {
        try {
          const r = await this.$http.delete(`${this.api}zones/${zone_id}`)
          this.getZones()
        } catch (e) {
          console.log(e)
        }
      },
      patchZone: async function (item) {
        try {
          const r = await this.$http.patch(`${this.api}zones/${item.zone_id}`, {
            zone_name: item.zone_name
          })
          this.getZones()
        } catch (e) {
          console.log(e)
        }
      },
      codeBx: async function() {
        try {
          const r = await this.$http.get(`${this.api}maxcodebx`)
          this.newQ.code = +(r.data[0].CodeBxMax) + 1
        } catch (e) {
          console.log(e)
        }
      }
    },
    mounted () {
      this.checkCrypto()
      this.getZones()
      this.codeBx()
    }
  }
</script>
<style>

</style>
